import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';

const STORAGE_KEY = 'lc-locale';

const stored =
  typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
const initialLng = stored === 'en' || stored === 'es' ? stored : 'es';

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLng;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initialLng,
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(next: 'en' | 'es') {
  i18n.changeLanguage(next);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, next);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next;
  }
}

export default i18n;
